export default __webpack_public_path__ + "static/media/full_logo_white.a0773c78.png";